import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NyAllEventComponent} from "./ny-all-event.component";

const routes: Routes = [
  {
    path: '',
    component: NyAllEventComponent,
    pathMatch: 'full',
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NyAllEventRoutingModule {}
